import { api } from "@/comn/features/config/ApiConfig";

const BASE = {
    rprtproxy: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/comn/rprtproxy`,
};

export const APIS_RPRTPROXY = {
    getRprtProxy: (origCfrmUuid: string) => {
        return api.get(`${BASE.rprtproxy}/${origCfrmUuid}`, {
            responseType: "arraybuffer",
        });
    },
};
